export function useClickOutside(callback: () => void) {
  return (node: HTMLElement) => {
    // in webcomponents any click inside of the webcomponent will have the event.target as the webcomponent.
    // so we have to check for `event.composedPath`...
    if (!node) {
      console.warn('useClickOutside: no node provided');
    }

    function handleClickOutside(event: Event) {
      // check for inside click
      if (event.composedPath().includes(node)) {
        // maybe do instead
        // node.contains(event.composedPath()[0]) ??
        return;
      }
      callback();
    }

    // we need to defer this for one event loop or it fires right away
    setTimeout(() => document.addEventListener('click', handleClickOutside));

    return {
      destroy: () => {
        document.removeEventListener('click', handleClickOutside);
      },
    };
  };
}
